import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <>
      <title>页面未找到 - 91吃瓜</title>
      <meta name="description" content="抱歉，您访问的页面不存在。返回91吃瓜首页，继续吃瓜。" />
      <meta name="robots" content="noindex, follow" />

      <Navbar />

      <main className="pt-16 md:pt-20 min-h-[70vh] flex items-center justify-center">
        <div className="text-center px-4">
          <span className="w-20 h-20 flex items-center justify-center mx-auto text-primary-300">
            <i className="ri-error-warning-line text-6xl" />
          </span>
          <h1
            className="mt-6 text-5xl md:text-7xl font-bold text-foreground-950"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            404
          </h1>
          <p className="mt-3 text-lg text-foreground-600">
            哎呀，这个瓜已经被人吃掉了
          </p>
          <p className="mt-1 text-sm text-foreground-500">
            页面不存在或已被删除
          </p>
          <Link
            to="/"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-line" />
            </span>
            返回首页
          </Link>
        </div>
      </main>

      <Footer />
    </>
  );
}